<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroRegra />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroRegra from "./../Components/Cadastros/CadastroRegra.vue";
export default {
  name: "RegisterRegra",
  components: {
    CadastroRegra,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
